import { Button } from 'semantic-ui-react';

export const getGuestsColumnDefs = (history) => [
  {
    headerName: 'Cédula',
    field: 'identification',
    width: 140,
    cellRenderer: (params) => params.data?.identification || '',
  },
  {
    headerName: 'Nombre',
    field: 'name',
    width: 220,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return `${data.name || ''} ${data.lastName || ''}`.trim();
    },
  },
  {
    headerName: 'Celular',
    field: 'phone',
    width: 140,
    cellRenderer: (params) => params.data?.phone || '',
  },
  {
    headerName: 'Email',
    field: 'email',
    width: 240,
    cellRenderer: (params) => params.data?.email || '',
  },
  {
    headerName: 'Ocupación',
    field: 'ocupation',
    width: 180,
    cellRenderer: (params) => params.data?.ocupation || '',
  },
  {
    headerName: 'Dashboard',
    field: 'id',
    width: 130,
    sortable: false,
    filter: false,
    cellRenderer: (params) => {
      const { data } = params;
      if (!data) return '';
      return (
        <Button
          onClick={() =>
            history.push(`/perfil/crecer?identification=${data.identification}&phone=${data.phone}`)
          }
        >
          Crecer
        </Button>
      );
    },
  },
];

const GuestRow = (props) => {
  const { guest } = props;

  const { identification, name, phone, lastName, ocupation, email } = guest;

  return (
    <tr>
      <td>
        <p style={{ margin: '0' }}>{identification}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>
          {name} {lastName}
        </p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{phone}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{email}</p>
      </td>
      <td>
        <p style={{ margin: '0' }}>{ocupation}</p>
      </td>
      <td>
        <Button
          onClick={() =>
            props.history.push(`/perfil/crecer?identification=${identification}&phone=${phone}`)
          }
        >
          Crecer
        </Button>
      </td>
    </tr>
  );
};

export default GuestRow;
